import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import SubpageTitle from '../../components/SubpageTitle';
import CartierSimplebar from '../../components/CartierSimplebar';
import TabletExitButton from '../../components/TabletExitButton';

const useStyles = makeStyles(() => ({
  container: {
    width: 785,
    maxWidth: 785,
  },
  mobileContainer: {
    width: '100%',
    '& iframe': {
      maxWidth: '100%',
    },
  },
}));

const hiddenTitles = ['The Venue', 'Confidentiality'];

const Custom = ({ name, content }) => {
  const classes = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <div className={clsx(classes.container, mobile && classes.mobileContainer)}>
      <TabletExitButton />
      <CartierSimplebar>
        {!hiddenTitles.includes(name) && (
          <SubpageTitle text={name} />
        )}
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </CartierSimplebar>
    </div>
  );
};

Custom.propTypes = {
  content: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default Custom;
